/**
 *  鼠标滚动加载更多	
 */
"use strict";
angular.module("mouseWheelShowMoreModule", [])
    .directive("mouseWheelShowMore", ["$timeout", function($timeout) {
        return {
            restrict: "A",
            replace: false,
            scope: {
                callback: "&"
            },
            link: function(scope, $element, $attrs) {
                var promise;
                $element.bind("mousewheel", function(e) {
                    var self = this;
                    var $this = $(self);
                    var $child = $this.children().eq(0);
                    var scrollTop = $this.scrollTop();
                    if (promise) {
                        $timeout.cancel(promise);
                        promise = null;
                    }
                    promise = $timeout(function() {
                        if (($this.height() + scrollTop) > ($child.height() - 100)) {
                            scope.callback();
                        }
                    }, 50);
                    return promise;
                });
            }
        };
    }])